export default __webpack_public_path__ + "static/5-0_HSR_Icon-d946e2d6f8a55eb27ea1a1427bb852e6.png";